import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { deleteLoan } from '../service/loanService'

export const useDeleteLoan = () => {
  const companyId = useSelector(contextCompanyIdSelector)!

  return useMutation({
    mutationKey: ['budget', 'loan', 'delete'],
    mutationFn: (loanId: number) => deleteLoan(companyId, loanId)
  })
}
